// 中国語 (簡体・繁体) はサポート外言語とする (JPTP_CANSEI-1504)。supportedLngs から
// 外れるため、ブラウザ言語や保存済み設定が zh でも fallback の en が使われる。
export const supportedLanguages = ["en", "ja"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

// ゲストは訪日外国人など多言語利用者が中心のため、既定言語を英語とする
// (shared-ui の既定は ja のため、guest はこの独自構成を createI18n に渡す。
//  docs/design/ゲストアプリの設計.md §3.2 #4)。
export const defaultLanguage: SupportedLanguage = "en";
export const STORAGE_LANG_KEY = "i18nextLng";

// 言語選択プルダウンの選択肢。中国語 (簡体・繁体) は非表示にする (JPTP_CANSEI-1504)。
// 削除ではなく非表示のため、hidden を付けてリストは 4 言語のまま維持し、
// 画面表示は VISIBLE_LANGUAGES を使う (concierge の JPTP_CANSEI-1481 と同方式)。
export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "ja", label: "日本語" },
  { code: "zh-CN", label: "中文 (简体)", hidden: true },
  { code: "zh-TW", label: "中文 (繁體)", hidden: true },
] as const;

export const VISIBLE_LANGUAGES = LANGUAGES.filter((l) => !("hidden" in l && l.hidden));
